import HeroLines from "shared/assets/images/hero-lines.png";
import { Input, Form } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { HeroSteps } from "./Hero";
import { useState } from "react";
import { autoSignIn, confirmSignUp, fetchAuthSession } from "aws-amplify/auth";
import { toast } from "react-toastify";
import { HERO_INFO, TOKEN } from "shared/constants/StorageConsts";
import StrmHeroLogo from "shared/assets/images/strm-hero-logo.png";
import { isDesktop } from "react-device-detect";
import { useHistory } from "react-router-dom";
import { saveReturnURL } from "shared/helpers/auth-functions";

interface Props {
  setCurrentStep: any;
}

const HeroVerification: React.FC<Props> = (props) => {
  const { setCurrentStep } = props;
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const form = Form.useFormInstance();
  const { t } = useTranslation();
  const confirmationCode = Form.useWatch("confirmationCode", form);

  const onClickNext = async () => {
    setLoading(true);
    try {
      const { confirmationCode, username, ...rest } = form.getFieldsValue(true);

      const { isSignUpComplete } = await confirmSignUp({
        username: username,
        confirmationCode: confirmationCode,
      });
      const paramsQuiz = {
        ...rest,
        instagram: { id: "no-data" },
        youtube: { id: "no-data" },
        name: rest.spotify?.name,
      };
      sessionStorage.setItem(
        HERO_INFO,
        JSON.stringify({
          ...paramsQuiz,
        }),
      );
      if (isSignUpComplete) {
        let autoSignedInSuccessed = false;
        try {
          const { isSignedIn } = await autoSignIn();
          autoSignedInSuccessed = isSignedIn;
        } catch (error: any) {}
        if (autoSignedInSuccessed) {
          const { idToken } = (await fetchAuthSession()).tokens ?? {};

          localStorage.setItem(TOKEN, idToken?.toString() ?? "");
          setCurrentStep(HeroSteps.Greetings);
          history.push("/strm-hero-success");
        } else {
          saveReturnURL("/strm-hero-success");
          history.push("/login");
        }
      } else {
        saveReturnURL("/strm-hero-success");
        history.push("/login");
      }
    } catch (error: any) {
      if (error.name === "CodeMismatchException")
        toast.error<string>(t("pages.VerificacaoLogin.codigoInvalido"));
      else toast.error(error.message);
    }
    setLoading(false);
  };

  if (loading)
    return (
      <div className="verification full-height">
        <div
          className="background-center"
          style={{
            backgroundImage: `url(${HeroLines})`,
            backgroundPositionY: isDesktop ? "30%" : "calc(50% + 60px)",
          }}
        >
          <div style={{ padding: "0 40px", textAlign: "center" }}>
            <img src={StrmHeroLogo} alt="logo" style={{ width: 94 }} />
            <p className="body-regular" style={{ marginTop: 120 }}>
              <Trans i18nKey={t("pages.StrmHero.analysingData")} />
            </p>
          </div>
        </div>
      </div>
    );

  return (
    <div className="verification full-height">
      <div
        className="background-center"
        style={{
          backgroundImage: `url(${HeroLines})`,
          backgroundPositionY: isDesktop ? "40%" : "calc(50% + 100px)",
        }}
      >
        <div style={{ padding: "0 40px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img src={StrmHeroLogo} alt="logo" style={{ width: 94 }} />
            <h4>{t("pages.StrmHero.checkYourEmail")}</h4>
            <p className="body-regular">
              <Trans i18nKey={t("pages.StrmHero.lastStep")} />
            </p>
          </div>
          <Form.Item
            name="confirmationCode"
            label={t("pages.VerificacaoLogin.codigo")}
            normalize={(value) => value?.trim()}
          >
            <Input />
          </Form.Item>
        </div>
      </div>
      <div className="footer">
        <button
          className="botao-roxo"
          onClick={onClickNext}
          disabled={!confirmationCode || loading}
          style={{ width: "100%" }}
          type="button"
        >
          {t("pages.StrmHero.verificarCodigo")}
        </button>
      </div>
    </div>
  );
};

export default HeroVerification;
